import {
  getCourse,
  getCourseHeaderImageURL,
  getCourseName
} from "seneca-common/features/course/state";

import { getAssignmentCourseId } from "../state";

type State = any;

export function getAssignmentCourse(state: State, assignmentId: string) {
  const courseId = getAssignmentCourseId(state, assignmentId);
  return getCourse(state, courseId);
}

export function getAssignmentCourseName(state: State, assignmentId: string) {
  const courseId = getAssignmentCourseId(state, assignmentId);
  return getCourseName(state, courseId);
}

export function getAssignmentCourseImageUrl(
  state: State,
  assignmentId: string
) {
  const courseId = getAssignmentCourseId(state, assignmentId);
  return getCourseHeaderImageURL(state, courseId);
}
